export const ENCAISSEE = 'Encaissée';
export const A_ENCAISSER = 'A encaisser';
export const ENCAISSEMENT_PARTIEL = 'Encaissement partiel';
export const IMPAYE_PARTIEL = 'Impayé partiel';
export const IMPAYE_TOTAL = 'Impayé total';
